import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { PRODUCT_HOME_BREAKPOINT } from '../../common/constants';
import { skeletonCSS } from '../../common/styles';
var gridSize = gridSizeFn();
export var productHomeButtonCSS = function productHomeButtonCSS(_ref) {
  var _ref2;

  var primaryButton = _ref.mode.primaryButton;
  return _ref2 = {
    alignItems: 'center',
    padding: gridSize / 2,
    borderRadius: 3,
    border: 0,
    background: 'none',
    display: 'flex',
    cursor: 'pointer',
    color: 'inherit',
    '&:first-of-type': {
      marginLeft: 0
    },
    '&::-moz-focus-inner': {
      border: 0
    },
    '&:hover': primaryButton.hover,
    '&:focus': _objectSpread(_objectSpread({}, primaryButton.focus), {}, {
      outline: 0
    }),
    '&:active': primaryButton.active,
    'div&': {
      pointerEvents: 'none'
    }
  }, _defineProperty(_ref2, "@media (max-width: ".concat(PRODUCT_HOME_BREAKPOINT - 1, "px)"), {
    margin: "0 ".concat(gridSize, "px")
  }), _defineProperty(_ref2, "@media (min-width: ".concat(PRODUCT_HOME_BREAKPOINT, "px)"), {
    margin: "0 ".concat(gridSize * 2, "px")
  }), _ref2;
};
export var productHomeButtonSkeletonCSS = productHomeButtonCSS;
var iconHeight = 28;
var heightCSS = {
  maxHeight: "".concat(iconHeight, "px")
};
export var productIconCSS = _defineProperty({
  // Ensure anything passed into
  // productHome is aligned correctly
  '& > *': {
    display: 'flex',
    maxHeight: 24
  }
}, "@media (min-width: ".concat(PRODUCT_HOME_BREAKPOINT, "px)"), {
  display: 'none'
});
export var productIconSkeletonCSS = function productIconSkeletonCSS(theme) {
  return _objectSpread(_objectSpread({
    borderRadius: '50%',
    width: "".concat(iconHeight, "px"),
    height: "".concat(iconHeight, "px")
  }, productIconCSS), skeletonCSS(theme));
};
export var customProductIconCSS = _objectSpread(_objectSpread({}, heightCSS), productIconCSS);
export var productLogoCSS = function productLogoCSS(logoMaxWidth) {
  var _ref3;

  return _ref3 = {
    // Ensure anything passed into
    // productHome is aligned correctly
    maxWidth: logoMaxWidth,
    '& > *': {
      display: 'flex',
      maxHeight: 24,
      maxWidth: logoMaxWidth
    }
  }, _defineProperty(_ref3, "@media (max-width: ".concat(PRODUCT_HOME_BREAKPOINT - 1, "px)"), {
    display: 'none'
  }), _defineProperty(_ref3, '&:only-child', {
    display: 'flex'
  }), _ref3;
};
export var siteTitleCSS = function siteTitleCSS(_ref4) {
  var _ref4$mode = _ref4.mode,
      color = _ref4$mode.navigation.color,
      borderRight = _ref4$mode.productHome.borderRight;
  return {
    marginLeft: "".concat(gridSize * 0.5, "px"),
    display: 'flex',
    alignItems: 'center',
    paddingRight: gridSize * 2,
    marginRight: gridSize / 2,
    borderRight: borderRight
  };
};
export var siteTitleSkeletonCSS = function siteTitleSkeletonCSS(theme) {
  return _objectSpread(_objectSpread(_objectSpread({}, siteTitleCSS(theme)), skeletonCSS(theme)), {}, {
    width: gridSize * 5,
    backgroundColor: 'transparent',
    '&:after': {
      content: '""',
      width: '100%',
      height: iconHeight / 2,
      backgroundColor: theme.mode.skeleton.backgroundColor,
      borderRadius: 4
    }
  });
};
export var productLogoSkeletonCSS = function productLogoSkeletonCSS(theme) {
  return _objectSpread(_objectSpread(_objectSpread({
    width: '120px',
    height: 24
  }, heightCSS), productLogoCSS(120)), skeletonCSS(theme));
};
export var customProductLogoCSS = function customProductLogoCSS(logoMaxWidth) {
  return _objectSpread(_objectSpread({}, heightCSS), productLogoCSS(logoMaxWidth));
};